var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-campaign-targeting-rule',[_c('div',[_vm._v("When a visitor is inactive for "+_vm._s(_vm.data / 1000)+" seconds")])])}
var staticRenderFns = []

export { render, staticRenderFns }